module.exports = __webpack_public_path__ + "img/offline.4c850ef2.svg";